// extracted by mini-css-extract-plugin
export default {"layoutContainer":"Layout_layoutContainer__nLNW0","mainContent":"Layout_mainContent__NyGQv","mobile":"Layout_mobile__kXUr8","tablet":"Layout_tablet__TJ+vU"};